import { generatePath, matchPath, useHistory } from "react-router-dom";
import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";

export const PATH_MY_RESOURCES = "/member/my-resources";

export const PARAMETER_TAB = "tab";
export const PARAMETER_MY_RESOURCE_ID = "myResourceId";
export const PARAMETER_MY_RESOURCES_PLAN_ENROLLMENT_ID = "planEnrollmentId";

export const PATH_MY_RESOURCES_TABS_DETAILS = `${PATH_MY_RESOURCES}/:${PARAMETER_TAB}/details/:${PARAMETER_MY_RESOURCE_ID}`;
export const PATH_MY_RESOURCES_DETAILS = `${PATH_MY_RESOURCES}/details/:${PARAMETER_MY_RESOURCE_ID}`;

export const PATH_MY_RESOURCES_REDIRECT_TO_DETAILS_FROM_ENROLLMENT = `${PATH_MY_RESOURCES}/redirect-details-from-enrollment/:${PARAMETER_MY_RESOURCES_PLAN_ENROLLMENT_ID}`;

export const PATH_MY_RESOURCES_TABS = `${PATH_MY_RESOURCES}/:${PARAMETER_TAB}`;

export const PATH_MY_RESOURCES_TABS_DETAILS_HISTORY = `${PATH_MY_RESOURCES_TABS_DETAILS}/history`;
export const PATH_MY_RESOURCES_DETAILS_HISTORY = `${PATH_MY_RESOURCES_DETAILS}/history`;

export const PATH_MY_RESOURCES_CANCELLATION = `${PATH_MY_RESOURCES}/cancellation/:${PARAMETER_MY_RESOURCES_PLAN_ENROLLMENT_ID}`;

export const PATH_MY_RESOURCES_PERSONAL_INSURANCE_DETAILS = `${PATH_MY_RESOURCES}/personal-insurance/details/:${PARAMETER_MY_RESOURCES_PLAN_ENROLLMENT_ID}`;

export const routeHelpersPersonalInsurancePolicyDetails = createRouteHelpers<{
  planEnrollmentId: string;
}>(PATH_MY_RESOURCES_PERSONAL_INSURANCE_DETAILS);

export const MY_RESOURCES_TAB_SLUGS = [
  "independent-contractor-insurance",
  "personal-insurance",
  "general-documents"
] as const;

export const routeHelpersMyResourcesTabs = createRouteHelpers<{
  tab: (typeof MY_RESOURCES_TAB_SLUGS)[number];
}>(PATH_MY_RESOURCES_TABS);

export const getPathnameMyResourcesTab = (
  tab: (typeof MY_RESOURCES_TAB_SLUGS)[number]
) =>
  generatePath(PATH_MY_RESOURCES_TABS, {
    [PARAMETER_TAB]: tab
  });

export const getPathnameMyResourcesDetails = (
  pathname: string,
  myResourceId: string
) => {
  const matchTabs = matchPath<{ tab: string }>(pathname, {
    path: PATH_MY_RESOURCES_TABS
  });

  if (matchTabs) {
    return generatePath(PATH_MY_RESOURCES_TABS_DETAILS, {
      [PARAMETER_MY_RESOURCE_ID]: myResourceId,
      [PARAMETER_TAB]: matchTabs.params.tab
    });
  } else {
    return generatePath(PATH_MY_RESOURCES_DETAILS, {
      [PARAMETER_MY_RESOURCE_ID]: myResourceId
    });
  }
};

export const getPathnameMyResourcesSubmitCancellation = (
  planEnrollmentId: string
) => {
  return generatePath(PATH_MY_RESOURCES_CANCELLATION, {
    [PARAMETER_MY_RESOURCES_PLAN_ENROLLMENT_ID]: planEnrollmentId
  });
};

export const getPathnameDetailsFromEnrollment = (planEnrollmentId: string) => {
  return generatePath(PATH_MY_RESOURCES_REDIRECT_TO_DETAILS_FROM_ENROLLMENT, {
    [PARAMETER_MY_RESOURCES_PLAN_ENROLLMENT_ID]: planEnrollmentId
  });
};

export const useGoToMyResourceDetails = () => {
  const history = useHistory();

  return (myResourceId: string) => {
    history.push(
      getPathnameMyResourcesDetails(history.location.pathname, myResourceId)
    );
  };
};

export const useGoToMyResourceDetailsHistory = () => {
  const history = useHistory();

  return (myResourceId: string) => {
    history.push(
      getPathnameMyResourcesDetails(history.location.pathname, myResourceId) +
        "/history"
    );
  };
};
